import { supabase } from '@/integrations/supabase/client';

export interface SessionHealthResult {
  valid: boolean;
  reason?: string;
}

export const validateSessionHealth = async (): Promise<SessionHealthResult> => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session) {
      return { valid: true, reason: 'no_session' };
    }
    
    // Check 1: JWT structure validation
    try {
      const payload = JSON.parse(atob(session.access_token.split('.')[1]));
      
      if (!payload.sub || !payload.exp) {
        console.error('🔒 Invalid JWT: missing claims', { hasSub: !!payload.sub, hasExp: !!payload.exp });
        return { valid: false, reason: 'missing_claims' };
      }
      
      // Check 2: JWT not expired (with 30s buffer)
      const expiryTime = payload.exp * 1000;
      const now = Date.now();
      if (expiryTime < now + 30000) {
        console.error('🔒 JWT expired or expiring soon', { 
          expiryTime: new Date(expiryTime).toISOString(),
          now: new Date(now).toISOString()
        });
        return { valid: false, reason: 'expired' };
      }
    } catch (e) {
      console.error('🔒 Malformed JWT token', e);
      return { valid: false, reason: 'malformed_jwt' };
    }
    
    // Check 3: User exists in database
    const { error } = await supabase.auth.getUser();
    if (error) {
      console.error('🔒 User not found in database', error);
      return { valid: false, reason: 'user_not_found' };
    }
    
    return { valid: true };
  } catch (error) {
    console.error('🔒 Session validation error:', error);
    return { valid: false, reason: 'validation_error' };
  }
};

export const clearInvalidSession = async () => {
  console.log('🧹 Clearing invalid session and all storage...');
  await supabase.auth.signOut();
  localStorage.clear();
  sessionStorage.clear();
};
